<template>
  <div>
    <div class="section-title">
      Inversión exitosa
    </div>
    <div class="section-content">
      <div class="button" @click="$router.push('/portfolio')">Ver portafólio</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
};
</script>

<style lang="scss" scoped>

</style>
